import React, { useMemo } from 'react';
import { Link as CKLink, LinkProps as CKLinkProps } from '@chakra-ui/react';
import { Link as RRLink, LinkProps } from 'react-router-dom';

type Props = Omit<LinkProps, 'to'> &
  CKLinkProps & {
    to: string;
  };

export const Link = ({ to, ...props }: Props) => {
  const isExternal = useMemo(
    () => ['http', 'www', 'tel', 'mailto'].some((v) => to.startsWith(v)),
    [to],
  );

  return (
    isExternal ? (
      /* @ts-ignore TS2590 - union too complex */
      <CKLink href={to.replace(/^www\./, 'https://')} isExternal {...props} />
    ) : (
      /* @ts-ignore TS2590 - union too complex */
      <CKLink as={RRLink} to={to} {...props} />
    )
  ) as React.ReactElement;
};
